const Notification = () => {
  return (
    <>
      <h4 class="ct_fs_32 ct_switzer_bold mb-4">Notification preference</h4>
      <div class="ct_right_box p-3 d-flex justify-content-between">
        <div>
          <h3 class="ct_fs_18 ct_fw_400 mb-2">Messages</h3>
          <p class="ct_text_clr_4B5563 mb-0">
            Stay informed without being disturbed — manage your message alerts.
          </p>
        </div>
        <div>
          <label class="toggle-switch">
            <input type="checkbox" />
            <div class="toggle-switch-background">
              <div class="toggle-switch-handle"></div>
            </div>
          </label>
        </div>
      </div>
      <hr class="my-0 ct_border_color_4B5563" />
      <div class="ct_right_box p-3 d-flex justify-content-between">
        <div>
          <h3 class="ct_fs_18 ct_fw_400 mb-2">Featured plan end</h3>
          <p class="ct_text_clr_4B5563 mb-0">
            Get notified before your featured plan expires.
          </p>
        </div>
        <div>
          <label class="toggle-switch">
            <input type="checkbox" />
            <div class="toggle-switch-background">
              <div class="toggle-switch-handle"></div>
            </div>
          </label>
        </div>
      </div>
      <hr class="my-0 ct_border_color_4B5563" />
      <div class="ct_right_box p-3 d-flex justify-content-between">
        <div>
          <h3 class="ct_fs_18 ct_fw_400 mb-2">SecurPoint+ plan end</h3>
          <p class="ct_text_clr_4B5563 mb-0">
            Receive alerts when your SecurPoint+ subscription is about to end.
          </p>
        </div>
        <div>
          <label class="toggle-switch">
            <input type="checkbox" />
            <div class="toggle-switch-background">
              <div class="toggle-switch-handle"></div>
            </div>
          </label>
        </div>
      </div>
      <hr class="my-0 ct_border_color_4B5563" />
      <div class="ct_right_box p-3 d-flex justify-content-between">
        <div>
          <h3 class="ct_fs_18 ct_fw_400 mb-2">Email</h3>
          <p class="ct_text_clr_4B5563 mb-0">
            Manage how SecurPoint sends notifications to your email.
          </p>
        </div>
        <div>
          <label class="toggle-switch">
            <input type="checkbox" />
            <div class="toggle-switch-background">
              <div class="toggle-switch-handle"></div>
            </div>
          </label>
        </div>
      </div>
    </>
  );
};

export default Notification;
